import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_AVAILABILITY_STORES_NEARBY } from "../../../../../queries/v3/queries/get-availability-stores-nearby.js";
import { fromAvailabilityStoresNearbyQueryToStore } from "../../../adapters/v3/hooks/api/adapters/fromAvailabilityStoresNearbyQueryToStore.js";
const useAvailabilityStoresNearby = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(GET_AVAILABILITY_STORES_NEARBY, {
    variables: void 0,
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onError(error) {
      console.error("Failed to fetch data for useAvailabilityStoresNearby: ", error);
    }
  });
  const { availabilityStoresNearby } = queryState.data ?? {};
  const data = React.useMemo(
    () => fromAvailabilityStoresNearbyQueryToStore(availabilityStoresNearby),
    [availabilityStoresNearby]
  );
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useAvailabilityStoresNearby as default,
  useAvailabilityStoresNearby
};
//# sourceMappingURL=use-availability-stores-nearby.js.map
